// Course List
// ===========

import './app';
import CourseFilter from './Course/CourseFilter';
import CourseListFactory from './Course/CourseListFactory';
import Dialog from './Components/Dialog';
import LayoutSwitch from './Components/LayoutSwitch';
import CalendarViewSwitch from './Components/CalendarViewSwitch';
import ListManager from './Components/ListManager';
import CatGroupManager from './Components/CatGroupManager';

const layoutSwitch = new LayoutSwitch('.layout-switch__btns', '.cl', 'CourseListLayout');
const calendarSwitch = new CalendarViewSwitch('#CalendarView', 'CourseListCalendarView');
const courseList = new ListManager(CourseListFactory, '/api/course', '.cl', '.clh-sum__value', calendarSwitch);
const courseFilter = new CourseFilter(courseList, '#CourseFilterForm', '.clh-badge', '/tanfolyami-naptar', calendarSwitch);
const courseFilterDialog = new Dialog(
    '#CourseFilterCollapse',
    () => {
        courseFilter.store();
    },
    () => {
        courseFilter.restore();
    },
    null,
    '#CourseFilterToggleBtn',
);
const catGroupManager = new CatGroupManager('#CategoryRadioGroup', '#MoreCategories', courseFilter);
